import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import List from "@mui/material/List";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";

import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import {
    Box,
    Checkbox,
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Typography
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { findUserAction } from "../../actions/adminAuthAction";
import { findEmployeeMatchedRoleAction } from "../../actions/employeeManagmentAction";
import {
    leadEnrollmentApprovalCreateAction,
    leadOwnerChangeAction
} from "../../actions/leadActions/leadActions";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Close } from "@mui/icons-material";
import AccessDeniedIcon from "../Leads/createLeads/AccessDeniedIcon";
import { shortListMethodFindAction } from "../../actions/leadActions/leadDocsActions";

const partnerFlow = [
    "Application Pending",
    "Application Submitted",
    "Application Rejected",
    "Application On Hold by University",
    "Document Pending",
    "Conditional Offer Letter",
    "Unconditional Offer Letter",
    "University Info Pending",
    "University Info Requested",
    "Deposit Pending",
    "Deposit Paid",
    "Tuition Fee Pending",
    "Tuition Fee Paid",
    "Refund In Progress",
    "Refund Credited",
    "CAS Applied",
    "CAS Received",
    "Interview Training",
    "Interview In Training",
    "Interview Failed",
    "Interview Completed",
    "Submitted for Visa",
    "Visa Applied",
    "Visa Received",
    "Visa Rejected",
    "Enrolled"
];

const inCountryGslFlow = [
    "Application Started",
    "Application Rejected",
    "Offer Letter Received",
    "Deposit Pending",
    "Deposit Paid",
    "Tuition Fee Pending",
    "Tuition Fee Paid",
    "Refund In Progress",
    "Refund Credited",
    "Enrolled"
];

const commonFlow = [
    "Application Started",
    "Application Rejected",
    // "Submitted Declaration",
    // "Declaration Completed",
    "Offer Letter Received",
    "Interview Training",
    "Interview In Training",
    "Interview Completed",
    "Deposit Pending",
    "Deposit Paid",
    "Tuition Fee Pending",
    "Tuition Fee Paid",
    "Refund In Progress",
    "Refund Credited",
    // "Visa in progress",
    "Submitted for Visa",
    "Visa Received",
    "Visa Rejected",
    // "Interview Failed",
    // "Financial Documents and Medical Waiting",
    // "Financial Documents and Medical Received",
    // "CAS Applied",
    // "CAS Received",
    // "Submitted for Visa",
    // "Visa Applied",
    "Enrolled"
];

const interviewerStatus = [
    "Interview Processing",
    "Mock section Schedule",
    "Practice Section",
    "Interview Completed"
];

const visaStatus = [
    // "Submitted university",
    "Visa Applied",
    "Visa Received",
    "Visa Rejected"
];

const excludedCountries = [
    "Ireland (+353)",
    "United Kingdom (+44)",
    "United States (+1)",
    "New Zealand (+64)",
    "Germany (+49)",
    "France (+33)",
    "Austria (+43)",
    "Australia (+61)",
    "Canada (+1)",
    "Luxembourg (+352)",
    "Lithuania (+370)",
    "Latvia (+371)"
];

function SimpleDialog(props) {
    const {
        onClose,
        selectedValue,
        open,
        appliedApplicationId,
        currentStatus,
        leadId,
        isLeadDuplicate,
        appliedMethod,
        leadedId,
        applyMethod
    } = props;

    const dispatch = useDispatch();
    const { id } = useParams();
    const [roleData, setRoleData] = useState();
    const [Status, setStatus] = useState([]);
    const [leadLockedPopUp, setLeadLockedPopUp] = useState(false);
    const [applicationStatus, setApplicationStatus] = useState([]);

    let {
        findEmployeeMatchedRoleSuccess,
    } = useSelector((state) => {
        return state.findEmployeeMatchedRole;
    });

    const [isStatusUpdated, setIsStatusUpdated] = useState(false);

    useEffect(() => {
        if (!isStatusUpdated) {
            if (applyMethod === "partner") {
                setStatus(partnerFlow);
            }

            setIsStatusUpdated(true);
        }
    }, [props.applicationCountry, isStatusUpdated]);

    const { leadShortListAppliedFindSuccess } =
        useSelector((state) => {
            return state.shortListMethodFind;
        });

    useEffect(() => {
        if (leadShortListAppliedFindSuccess) {
            leadShortListAppliedFindSuccess.map((value) => {
                if (value.id === appliedApplicationId) {
                    setApplicationStatus(value.methodStatus);
                }
            });
        }
    }, [leadShortListAppliedFindSuccess, appliedApplicationId]);

    useEffect(() => {
        dispatch(shortListMethodFindAction(appliedApplicationId))
    }, [appliedApplicationId, dispatch])

    useEffect(() => {
        if (findEmployeeMatchedRoleSuccess) {
            if (findEmployeeMatchedRoleSuccess?.role === null) {
                findEmployeeMatchedRoleSuccess.role = "admin";
            }
            setRoleData(findEmployeeMatchedRoleSuccess);
        }
    }, [findEmployeeMatchedRoleSuccess]);

    useEffect(() => {
        dispatch(findEmployeeMatchedRoleAction("interviewer"));
    }, [dispatch]);

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleListItemClick = (value) => {
        onClose(value);
    };

    const dialogStyle = {
        left: "80vh",
        width: "auto",
        border: "1.5px solid black",
        overflowY: "scroll",
        scrollbarWidth: "thin",
        bottom:
            roleData !== undefined &&
                roleData?.role !== null &&
                roleData?.role.roleName == "visa officer"
                ? "-21vh"
                : roleData !== undefined &&
                    roleData?.role !== null &&
                    roleData?.role.roleName === "interviewer"
                    ? "-12vh"
                    : null
    };

    const changeApplicationStatusHandler = (status, statusName, index) => {
        // if (
        //     (statusName === "Deposit Pending" || statusName === "Deposit Paid") &&
        //     applicationStatus !== "Offer Letter Received" &&
        //     applicationStatus !== "Conditional Offer Letter" &&
        //     applicationStatus !== "Unconditional Offer Letter" &&
        //     applicationStatus !== "Deposit Pending" &&
        //     applicationStatus !== "I20 Applied" &&
        //     applicationStatus !== "I20 Received" &&
        //     applicationStatus !== "Financial Documents" &&
        //     applicationStatus !== "Financial Documents and Medical Waiting" &&
        //     applicationStatus !== "Financial Documents and Medical Received" &&
        //     applicationStatus !== "AIP Received" &&
        //     applicationStatus !== "Started Block Account" &&
        //     applicationStatus !== "Campus France Submitted" &&
        //     applicationStatus !== "Interview Training" &&
        //     applicationStatus !== "Interview In Training" &&
        //     applicationStatus !== "Interview Failed" &&
        //     applicationStatus !== "Interview Completed" &&
        //     applicationStatus !== "NOC" &&
        //     applicationStatus !== "Financial Documents" &&
        //     "Insurance and Accommodation Received" &&
        //     applicationStatus !== "Financial Document waiting" &&
        //     applicationStatus !== "Financial Documents Received" &&
        //     applicationStatus !== "Started maintenance fund" &&
        //     applicationStatus !== "GTE or GS" &&
        //     applicationStatus !== "GTE Approved" &&
        //     applicationStatus !== "GIC"
        // ) {
        //     Swal.fire({
        //         icon: "info",
        //         title: "Invalid Status Selection",
        //         text: "You can only do the Deposit transactions after the Offer Letter Received.",
        //         confirmButtonText: "OK"
        //     });
        //     handleClose();
        //     return;
        // }

        if (
            (statusName === "Tuition Fee Pending" ||
                statusName === "Tuition Fee Paid") &&
            applicationStatus !== "Deposit Paid" &&
            applicationStatus !== "Tuition Fee Pending" &&
            applicationStatus !== "Submitted for Visa" &&
            applicationStatus !== "Visa Applied" &&
            applicationStatus !== "Visa Received" &&
            applicationStatus !== "Visa Rejected"
        ) {
            Swal.fire({
                icon: "info",
                title: "Invalid Status Selection",
                text: "You can only do Tuition Fee transactions after the Deposit Paid.",
                confirmButtonText: "OK"
            });
            handleClose();
            return;
        }

        if (applicationStatus === "Visa Rejected" && statusName === "Enrolled") {
            Swal.fire(
                "Rejected!",
                "Your visa is Rejected. Unable to enroll",
                "error"
            );
            handleClose();
            return;
        } else if (
            applicationStatus === "Offer Letter Received" &&
            statusName === "Application Rejected"
        ) {
            Swal.fire({
                icon: "info",
                title: "Previous Status Unavailable",
                text: "You cannot revert to the previous status. Your offer letter has been received.",
                confirmButtonText: "OK"
            });
            handleClose();
            return;
        } else if (
            applicationStatus === "Offer Letter Received" &&
            statusName === "Application Started"
        ) {
            Swal.fire({
                icon: "info",
                title: "Previous Status Unavailable",
                text: "You cannot revert to the previous status. Your offer letter has been received.",
                confirmButtonText: "OK"
            });
            handleClose();
            return;
        }

        if (!isLeadDuplicate) {
            if (
                currentStatus?.trim() !== "Submitted declaration" ||
                (currentStatus?.trim() == "Submitted declaration" &&
                    statusName?.trim() == "Declaration Completed") ||
                (currentStatus?.trim() == "Submitted declaration" &&
                    statusName?.trim() == "Application Started") ||
                (currentStatus?.trim() == "Submitted declaration" &&
                    statusName?.trim() == "Application Rejected")
            ) {
                if (appliedMethod !== "In Country GSL") {
                    if (
                        statusName === "Submitted to the university" ||
                        statusName === "Interview Training" ||
                        statusName === "Submitted for Visa" ||
                        statusName === "Visa received" ||
                        statusName === "Visa Applied" ||
                        statusName === "Offer Letter Received" ||
                        statusName === "Unconditional Offer" ||
                        statusName === "Conditional Offer Letter" ||
                        statusName === "Unconditional Offer Letter" ||
                        statusName === "Submitted Declaration" ||
                        statusName === "Declaration Completed" ||
                        statusName === "Deposit Paid" ||
                        statusName === "Refund In Progress" ||
                        statusName === "Enrolled"
                    ) {
                        props.handleOpenDialog(status, statusName);
                    } else {
                        dispatch(
                            leadOwnerChangeAction(
                                "",
                                id ? id : leadId,
                                "",
                                "",
                                statusName,
                                props.appliedApplicationId
                            )
                        );
                        handleClose();
                    }
                } else {
                    if (appliedMethod === "In Country GSL" && statusName === "Enrolled") {
                        dispatch(
                            leadEnrollmentApprovalCreateAction(
                                leadedId,
                                "In Country GSL",
                                appliedApplicationId
                            )
                        );
                        handleClose();
                        Swal.fire({
                            icon: "info",
                            title: "Approval Request",
                            text: "Approval Request has been send"
                        });
                    } else {
                        if (
                            commonFlow.includes(statusName) &&
                            statusName !== "Application Started" &&
                            statusName !== "Application Rejected" &&
                            statusName !== "Refund Credited" &&
                            statusName !== "Deposit Pending" &&
                            statusName !== "Tuition Fee Pending" &&
                            statusName !== "Tuition Fee Paid"
                        ) {
                            props.handleOpenDialog(status, statusName);
                        } else {
                            dispatch(
                                leadOwnerChangeAction(
                                    "",
                                    id ? id : leadId,
                                    "",
                                    "",
                                    statusName,
                                    props.appliedApplicationId
                                )
                            );
                            handleClose();
                        }
                    }
                }
            } else {
                Swal.fire(
                    "Error!",
                    "Futher application status only can change after the decalration is completed.",
                    "warning"
                );
                handleClose();
            }
        } else {
            setLeadLockedPopUp(true);
            // handleClose()
        }
    };

    return (
        <>
            <Dialog
                onClose={handleClose}
                open={open}
                PaperProps={{
                    style: {
                        ...dialogStyle,
                        width: "auto",
                        maxWidth: "none",
                        minWidth: "550px",
                        padding: "17px"
                    }
                }}
            >
                <DialogTitle>Select Status</DialogTitle>
                <List sx={{ pt: 0 }}>
                    {roleData === undefined ? null : roleData?.role !== "admin" ? (
                        <>
                            {roleData !== undefined &&
                                roleData?.role !== null &&
                                roleData?.role?.roleName === "interviewer"
                                ? interviewerStatus.map((status) => (
                                    <MenuItem
                                        sx={{
                                            fontSize: "15px",
                                            fontWeight: 400,
                                            backgroundColor:
                                                props?.menuStatus === status
                                                    ? "#EFEFEF"
                                                    : "transparent"
                                        }}
                                    >
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={currentStatus?.toLowerCase().trim()}
                                            name="radio-buttons-group"
                                        >
                                            <FormControlLabel
                                                value={status.toLowerCase()}
                                                control={
                                                    <Radio
                                                        sx={{
                                                            color: "#F8469A",
                                                            "&.Mui-checked": {
                                                                color: "#F8469A"
                                                            },
                                                            width: "16px",
                                                            height: "16px",
                                                            margin: 2
                                                        }}
                                                        icon={<RadioButtonUncheckedIcon />}
                                                        checkedIcon={<CheckCircleTwoToneIcon />}
                                                        id={`checkbox-${status}`}
                                                        //   checked={showNameColumn === true ? true : false}
                                                        onChange={(e) => {
                                                            dispatch(
                                                                leadOwnerChangeAction(
                                                                    "",
                                                                    id ? id : leadId,
                                                                    "",
                                                                    "",
                                                                    status,
                                                                    props.appliedApplicationId
                                                                )
                                                            );
                                                            handleClose();
                                                        }}
                                                    />
                                                }
                                                label={status}
                                            />
                                        </RadioGroup>
                                    </MenuItem>
                                ))
                                : roleData !== undefined &&
                                    roleData?.role !== null &&
                                    roleData?.role.roleName == "visa officer"
                                    ? visaStatus.map((status, index) => (
                                        <MenuItem
                                            sx={{ fontSize: "15px", fontWeight: 400 }}
                                            onClick={() => { }}
                                        >
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={currentStatus?.toLowerCase().trim()}
                                                name="radio-buttons-group"
                                            >
                                                <FormControlLabel
                                                    value={status.toLowerCase()}
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#F8469A",
                                                                "&.Mui-checked": {
                                                                    color: "#F8469A"
                                                                },
                                                                width: "16px",
                                                                height: "16px",
                                                                margin: 2
                                                            }}
                                                            icon={<RadioButtonUncheckedIcon />}
                                                            checkedIcon={<CheckCircleTwoToneIcon />}
                                                            id={`checkbox-${status}`}
                                                            //   checked={showNameColumn === true ? true : false}
                                                            onChange={(e) => {
                                                                if (
                                                                    status !== "Visa Applied" &&
                                                                    status !== "Submitted to the university"
                                                                ) {
                                                                    dispatch(
                                                                        leadOwnerChangeAction(
                                                                            "",
                                                                            id ? id : leadId,
                                                                            "",
                                                                            "",
                                                                            status,
                                                                            props.appliedApplicationId
                                                                        )
                                                                    );
                                                                    handleClose();
                                                                } else {
                                                                    changeApplicationStatusHandler(
                                                                        e.target.checked,
                                                                        status,
                                                                        index
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    }
                                                    label={status}
                                                />
                                            </RadioGroup>
                                        </MenuItem>
                                    ))
                                    : roleData !== undefined &&
                                        roleData?.role !== null &&
                                        roleData?.role?.roleName !== "interviewer" &&
                                        roleData?.role.roleName !== "visa officer"
                                        ? Status?.map((status, index) => (
                                            <MenuItem
                                                sx={{ fontSize: "15px", fontWeight: 400 }}
                                                onClick={() => {
                                                    const checkbox = document.getElementById(
                                                        `checkbox-${status}`
                                                    );
                                                    if (checkbox) {
                                                        checkbox.click();
                                                    }
                                                }}
                                            >
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    defaultValue={currentStatus?.toLowerCase().trim()}
                                                    name="radio-buttons-group"
                                                >
                                                    <FormControlLabel
                                                        value={status.toLowerCase()}
                                                        control={
                                                            <Radio
                                                                sx={{
                                                                    color: "#F8469A",
                                                                    "&.Mui-checked": {
                                                                        color: "#F8469A"
                                                                    },
                                                                    width: "16px",
                                                                    height: "16px",
                                                                    margin: 2
                                                                }}
                                                                icon={<RadioButtonUncheckedIcon />}
                                                                checkedIcon={<CheckCircleTwoToneIcon />}
                                                                id={`checkbox-${status}`}
                                                                //   checked={showNameColumn === true ? true : false}
                                                                onChange={(e) =>
                                                                    changeApplicationStatusHandler(
                                                                        e.target.checked,
                                                                        status,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        }
                                                        label={status}
                                                    />
                                                </RadioGroup>
                                            </MenuItem>
                                        ))
                                        : null}
                        </>
                    ) : (
                        Status.map((status, index) => (
                            <MenuItem
                                sx={{ fontSize: "15px", fontWeight: 400 }}
                                onClick={() => {
                                    const checkbox = document.getElementById(
                                        `checkbox-${status}`
                                    );
                                    if (checkbox) {
                                        checkbox.click();
                                    }
                                }}
                            >
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue={currentStatus?.toLowerCase().trim()}
                                    name="radio-buttons-group"
                                >
                                    <FormControlLabel
                                        value={status.toLowerCase()}
                                        control={
                                            <Radio
                                                sx={{
                                                    color: "#F8469A",
                                                    "&.Mui-checked": {
                                                        color: "#F8469A"
                                                    },
                                                    width: "16px",
                                                    height: "16px",
                                                    margin: 2
                                                }}
                                                icon={<RadioButtonUncheckedIcon />}
                                                checkedIcon={<CheckCircleTwoToneIcon />}
                                                id={`checkbox-${status}`}
                                                //   checked={showNameColumn === true ? true : false}
                                                onChange={(e) =>
                                                    changeApplicationStatusHandler(
                                                        e.target.checked,
                                                        status,
                                                        index
                                                    )
                                                }
                                            />
                                        }
                                        label={status}
                                    />
                                </RadioGroup>
                            </MenuItem>
                        ))
                    )}
                </List>
            </Dialog>

            {/* Lead loked popup */}

            {leadLockedPopUp && (
                <Dialog
                    open={leadLockedPopUp}
                    onClose={() => setLeadLockedPopUp(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        zIndex: "9999",
                        // background:"red",
                        "& .MuiDialog-paper": {
                            width: "100%",
                            borderRadius: "5px",
                            p: "15px",
                            textAlign: "center"
                        }
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end"
                        }}
                    >
                        <Close
                            sx={{
                                cursor: "pointer"
                            }}
                            onClick={() => setLeadLockedPopUp(false)}
                        />
                    </Box>
                    <Typography
                        sx={{
                            color: "#05050F",
                            fontSize: "26px",
                            fontWeight: "700"
                        }}
                    >
                        Lead locked
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mt: "-10px"
                        }}
                    >
                        <AccessDeniedIcon />
                    </Box>
                    <Typography
                        sx={{
                            color: "#717171",
                            fontSize: "16px",
                            mb: "10px"
                        }}
                    >
                        Duplicate Lead.Wait for approval !
                    </Typography>
                </Dialog>
            )}
        </>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired
};

export default function PartnerMenuBar({
    openTrue,
    handleClose,
    anchorEl,
    handleOpenDialog,
    appliedApplicationId,
    menuStatus,
    currentStatus,
    applicationCountry,
    isLeadDuplicate,
    appliedMethod,
    leadId,
    applyMethod
}) {
    const [open, setOpen] = useState(openTrue);
    const [selectedValue, setSelectedValue] = useState(partnerFlow[0]);

    return (
        <div>
            <SimpleDialog
                selectedValue={selectedValue}
                open={open}
                onClose={handleClose}
                handleOpenDialog={handleOpenDialog}
                appliedApplicationId={appliedApplicationId}
                menuStatus={menuStatus}
                currentStatus={currentStatus}
                leadId={leadId}
                applicationCountry={applicationCountry}
                isLeadDuplicate={isLeadDuplicate}
                appliedMethod={appliedMethod}
                leadedId={leadId}
                applyMethod={applyMethod}
            />
        </div>
    );
}
